if (!customElements.get('usp-scroller')) {
  customElements.define(
    'usp-scroller',
    class USPScrolle extends HTMLElement {
      constructor() {
        super();
        this.parentSelector = this;
        const clone = this.parentSelector.innerHTML;
        const firstElement = this.parentSelector.children[0];
        let i = 0;

        // Retrieve the delay attribute value from the element
        const delay = parseInt(this.getAttribute('delay')) || 0; // Default to 0 if attribute not present or invalid

        this.parentSelector.insertAdjacentHTML('beforeend', clone);
        this.parentSelector.insertAdjacentHTML('beforeend', clone);
        this.parentSelector.insertAdjacentHTML('beforeend', clone);

        // Start the interval after the specified delay
        setTimeout(function () {
          setInterval(function () {
            firstElement.style.marginLeft = `-${i}px`;
            if (i > firstElement.clientWidth) {
              i = 0;
            }
            i = i + 0.1;
          }, 0);
        }, delay);
      }
    }
  );
}
